var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rect',{attrs:{"width":_vm.zoom * _vm.win.width,"height":_vm.zoom * _vm.win.height,"dfill":"#bebebe","fill":"transparent","stroke":"none"}})}
var staticRenderFns = []

export { render, staticRenderFns }